module.exports = __webpack_public_path__ + "images/the-mystic-abf94c075c9ae19853c6ccd69f19ffde.png";